import React from 'react';
import clsx from 'clsx';

const PlanCardHeader = ({ tierName, isMostPopular, isLimitedOffer }) => {
  return (
    <div className="flex justify-between items-center">
      <p className="font-inter-variable text-v3-h7 font-bolder text-v3-black-max mb-0.5">
        {tierName}
      </p>
      {isLimitedOffer && (
        <div className="flex justify-center items-center gap-[10px] py-v3-xxs px-[12px] rounded-full bg-v3-red-dark">
          <span className="font-inter-variable text-v3-h11 font-medium leading-[20px] text-[#fff]">
            Limited Offer
          </span>
        </div>
      )}
      {!isLimitedOffer && isMostPopular && (
        <div className="flex justify-center items-center gap-[10px] py-v3-xxs px-[12px] rounded-full bg-v3-green-primary">
          <span className="font-inter-variable text-v3-h11 font-medium leading-[20px] text-[#fff]">
            Most Popular
          </span>
        </div>
      )}
    </div>
  );
};

export default PlanCardHeader;

